import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    RESET,
    SET as patientSET
} from 'one-state-subject/src/types';

import {
    setAction,
    reinitAction
} from 'one-state-pending-referrals/src/actions';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    SETPENDINGREFERRALS = 'one-state-pending-referrals/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


/**
 * This Fuction will fetch the data of pending referals epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchPendingRefEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { log, server, agentId, teamName, alertnotification, settings: {
            servers,
            epicendpoints: {
                getpendingreferrals,
                apitoken
            },
            uisettings: {
                dashboardapiconfig: {
                    getpendingreferrals: getpendingreferralsApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "PatientID": datares?.id,
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(getpendingreferrals, data, apitoken, locations, log, 'POST', alertnotification);
                        } else {
                            response = server.post({
                                path: getpendingreferrals,
                                data: data,
                                headers: headers
                            })
                                .then((responsefound: any) => responsefound)
                                .catch((responseresult: any) => {
                                    log.error(
                                        "ccw-gadget,pendingreferrals-epic",
                                        "fetch-Referrals-epic", {
                                        responseresult
                                    }
                                    );

                                    let errorbuild: ErrorObject = {
                                        source: "PendingReferrals",
                                        type: "error",
                                        status: responseresult?.status,
                                        erroritems: responseresult?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!getpendingreferralsApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.referrals)];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1001" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  }
                                  else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "184" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  }
                                  else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                actions.push(pushToDisposition(disp));
                            }
                            // clear skeleton for pending bills
                            let skeletonpendingreferrals: Skeleton = {
                                pendingReferrals_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonpendingreferrals));
                            return actions;
                        })
                        // map((response: any) => setAction(response))
                    )
            })
        )
    }
);
/**
 * This Fuction will clear data of pending referals epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearPendingRefEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,pendingreferrals-epic",
            "Reset-Referrals-epic", {
        });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);

